import { trackEvent, trackFeatureExposedEvent, trackUIEvent, sanitizeEventProperties } from "../common/analytics";
import Tracking from "../common/tracking";
import * as Platforms from "../common/tracking/platforms";

export default class ImktTracking {
  // expose utils for Apollo to call from external experiment code.
  apollo = {
    Tracking,
    Platforms,
  };

  // Track events for analytics
  static trackEvent(eventName: string, eventProperties?: {}) {
    trackEvent(eventName, eventProperties);
  }

  static trackUIEvent(trackEventName: string, eventProperties?: {}) {
    trackUIEvent(trackEventName, eventProperties);
  }

  static trackFeatureExposedEvent(actionSubject: string, featureGroup: any, eventProperties?: {}) {
    trackFeatureExposedEvent(actionSubject, featureGroup, eventProperties);
  }

  static sanitizeEventProperties(eventProperty: {}) {
    return sanitizeEventProperties(eventProperty);
  }

  /* use the below function for tracking content that was not rendered server-side and has thus escaped the purview of the tracking wrapper */
  static trackLateRenderedEvent(eventName: string, eventTarget: HTMLElement) {
    if (
      eventTarget.tagName == "A" ||
      (eventTarget.tagName == "BUTTON" && eventTarget.dataset.uuid)
    ) {
      let attributes = [
        "uuid",
        "event",
        "eventComponent",
        "eventContainer",
        "parentLabel",
        "eventColumn",
        "schemaVersion",
      ];
      let eventData = {
        label: eventTarget.dataset.label
          ? eventTarget.dataset.label
          : eventTarget.innerText,
      };
      attributes.forEach((attribute) => {
        eventData[attribute] = eventTarget.dataset[attribute];
      });
      this.trackEvent(eventName, eventData);
    }
  }
}
